const NotFoundPage = () => {
  return (
    <div className="flex items-center justify-center w-screen h-screen">
      <div className="px-4 lg:py-12">
        <div className="lg:gap-4 lg:flex">
          <div className="flex flex-col items-center justify-center md:py-24 lg:py-32">
            <h1 className="font-bold text-blue-600 text-9xl">404</h1>
            <p className="mb-2 text-2xl font-bold text-center text-gray-800 md:text-3xl">
              <span className="text-red-500">Oops!</span> Page not found
            </p>
            <p className="mb-8 text-center text-gray-500 md:text-lg">
              The page you’re looking for doesn’t exist.
            </p>
            <a
              onClick={() => window.open(process.env.REACT_APP_DOMAIN, "_self")}
              className="px-6 py-2 text-sm font-semibold text-blue-800 bg-blue-300"
            >
              Go home
            </a>
          </div>
          <div className="mt-4">
            <img
              src="https://i.kym-cdn.com/entries/icons/original/000/013/564/doge.jpg"
              alt="img"
              className="object-cover w-full h-full"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
